import './sentry'; // must be first import
import 'airbnb-js-shims';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import './index.css';

import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import i18n from './i18n';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { store } from './store/store';

import { theme } from './theme';

const app = ReactDOM.createRoot(document.getElementById('app'));
app.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </I18nextProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
